import { gql, useMutation } from '@apollo/client'
import { useEffect } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import Heading from 'components/v2/Heading'
import FormLayout from 'features/App/components/FormLayout'
import { ForbiddenView } from 'features/App/components/ForbiddenView'
import { withLastUrl } from 'features/App/components/WithLastUrl'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { NewInventory } from 'features/Inventories/components/NewInventory'
import { canWriteInventory, isSuperAdmin } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'

const messages = defineMessages({
  helmet: {
    id: 'inventories.new.helmet',
    defaultMessage: 'New Inventory | Nexbus Admin'
  }
})

const CREATE_INVENTORY = gql`
  mutation CreateInventory($inventory: CreateInventoryInput!) {
    createInventory(input: $inventory)
  }
`

const NewInventoryView = (): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const login = useLogin()

  useEffect((): TSFixMe => {
    document.title = intl.formatMessage(messages.helmet)
  }, [])

  const [createInventory, { loading, error }] = useMutation(CREATE_INVENTORY, {
    onCompleted() {
      navigate('/inventories')
    }
  })

  const handleSubmit = (inventory: TSFixMe): TSFixMe => {
    const payload = {
      companyID: inventory.company.id,
      name: inventory.name,
      type: inventory.type,
      address: {
        line1: inventory.address.line1,
        line2: inventory.address.line2,
        cityID: inventory.address.city.id || null,
        zipCode: inventory.address.zipCode
      },
      userIDs: inventory.users.map(({ id }: TSFixMe): TSFixMe => id)
    }

    createInventory({
      variables: {
        inventory: payload
      }
    })
  }

  if (!canWriteInventory(login.accessToken.policies)) {
    return <ForbiddenView feature={FEATURES.INVENTORY} />
  }

  let initialInventory = {}
  const showCompany = isSuperAdmin(login.accessToken.conditions)

  if (!showCompany) {
    initialInventory = {
      company: {
        id: login.accessToken.companyId
      }
    }
  }

  return (
    <div>
      <FormLayout.Header>
        <Heading.H3>
          <FormattedMessage id="spanish.inventories.new.title" defaultMessage="Registrar ubicación" />
        </Heading.H3>
      </FormLayout.Header>

      <FormLayout.Content>
        <NewInventory
          inventory={initialInventory}
          showCompany={showCompany}
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
        />
      </FormLayout.Content>
    </div>
  )
}

export default withLastUrl(NewInventoryView)
